import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';

import { clearCacheMutation } from '@queries';
import { ButtonSpinnerDarkIcon } from '@svgs';

export const ClearCache = ({}) => {
  // delete confirmation
  const [showConfirmation, setShowConfirmation] = useState(false);

  // clear cache mutation
  const mutation = useMutation(
    clearCacheMutation({
      onSuccess: () => {
        setShowConfirmation(false);
      },
      onError: (error) => {
        console.error('Failed to clear cache:', error);
      },
    }),
  );

  const isPending = mutation.isPending;

  const onClearCache = async () => {
    mutation.mutate();
  };

  return (
    <div className="sb-message sb-flex sb-message-delete">
      <div className="sb-flex sb-message-delete-inner">
        <span className="sb-message-icon"></span>
        <div className="sb-message-content">
          <p className="sb-message-title">Clear cache</p>
          <p className="sb-message-msg">
            Clear the Website, Page and Object cache for the organization.
          </p>
        </div>
      </div>
      {(!showConfirmation || isPending) && (
        <button
          type="button"
          className="sb-btn sb-btn-delete"
          onClick={() => setShowConfirmation(true)}
        >
          {isPending ? `Clearing...` : 'Clear cache'}
          {isPending && <ButtonSpinnerDarkIcon />}
        </button>
      )}
      {showConfirmation && !isPending && (
        <div>
          <button
            type="button"
            className="sb-btn sb-btn-delete-confirm"
            onClick={onClearCache}
          >
            Confirm
          </button>
          <button
            type="button"
            className="sb-btn sb-btn-delete"
            onClick={() => setShowConfirmation(false)}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};
